(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 93218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ Layout_HomepageFooter; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 64 modules
var theme = __webpack_require__(41592);
// EXTERNAL MODULE: ./src/components/Layout/Footer/index.ts + 1 modules
var Footer = __webpack_require__(29192);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Layout/HomepageFooter.tsx







var HomepageFooter = function HomepageFooter() {
  var _theme$palette$care, _theme$palette$care2;

  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
    featured: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          color: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[600],
          fontWeight: 400
        },
        href: "https://www.forbes.com/sites/nextavenue/2019/06/12/ways-to-vet-a-caregiver-or-caregiving-agency/#546bd23a8a7f",
        target: "_blank",
        children: "Ways To Vet A Caregiver Or Caregiving Agency"
      }), ' ', "From Forbes. \xA9 2019 Forbes. All rights reserved. Used under license."]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          color: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.grey[600],
          fontWeight: 400
        },
        href: "https://www.huffpost.com/entry/senior-care_b_11057736",
        target: "_blank",
        children: "Senior Care: Hope for the Best, Prepare for the Worst"
      }), ' ', "From HuffPost. \xA9 2016 Oath Inc.. All rights reserved. Used under license."]
    })],
    isMobile: isMobile
  });
};

/* harmony default export */ var Layout_HomepageFooter = (HomepageFooter);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Layout/index.ts


/***/ }),

/***/ 90683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ FeatureSection_FeatureSection; }
});

// UNUSED EXPORTS: NumberedTile, Tiles

// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 64 modules
var theme = __webpack_require__(41592);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/NumberedTile.tsx





var NumberedTile = function NumberedTile(_ref) {
  var description = _ref.description,
      number = _ref.number,
      title = _ref.title,
      link = _ref.link,
      hideNumberBackground = _ref.hideNumberBackground,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  var isMobile = (0,useMediaQuery/* default */.Z)(theme/* theme.breakpoints.down */.rS.breakpoints.down('md'));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    alignItems: !isMobile ? 'flex-start' : 'center',
    container: true,
    sx: {
      gap: {
        xs: theme/* theme.spacing */.rS.spacing(2),
        md: theme/* theme.spacing */.rS.spacing(3)
      }
    },
    direction: isMobile ? 'column' : 'row',
    justifyContent: "center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        backgroundColor: !hideNumberBackground ? theme/* theme.palette.care.red.100 */.rS.palette.care.red[100] : 'unset',
        borderRadius: '50%',
        color: theme/* theme.palette.care.red.400 */.rS.palette.care.red[400],
        fontSize: '36px',
        fontWeight: 'bold',
        height: '50px',
        padding: theme/* theme.spacing */.rS.spacing(1.5),
        textAlign: 'center',
        width: '50px'
      },
      children: number
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      justifyContent: "space-between",
      sm: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "h3",
        sx: {
          textAlign: {
            xs: 'center',
            md: 'left'
          }
        },
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "body1",
        sx: {
          textAlign: {
            xs: 'center',
            md: 'left'
          },
          margin: hideTileDescriptionMarginTop ? theme/* theme.spacing */.rS.spacing(0.5, 0, 3) : theme/* theme.spacing */.rS.spacing(3, 0, 3)
        },
        color: "secondary",
        children: description
      }), link]
    })]
  });
};

/* harmony default export */ var FeatureSection_NumberedTile = (NumberedTile);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/Tiles.tsx



var features = [{
  description: "Set up a pay cadence that works for you, and we'll onboard your employees to save you time.",
  number: 1,
  title: 'Customized payroll process'
}, {
  description: 'We prepare your quarterly and year-end taxes - filed on-time, every time. Guaranteed.',
  number: 2,
  title: 'Tax returns filed automatically'
}, {
  description: 'Contact our award-winning tax, payroll & HR specialists to have your questions answered quickly and accurately.',
  number: 3,
  title: 'Unlimited access to experts'
}];

var Tiles = function Tiles(_ref) {
  var hideNumberBackground = _ref.hideNumberBackground,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    direction: "column",
    "data-testid": "tiles-container",
    children: features.map(function (feature) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_NumberedTile, {
          number: feature.number,
          title: feature.title,
          description: feature.description,
          hideNumberBackground: hideNumberBackground,
          hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
        })
      }, feature.number);
    })
  });
};

/* harmony default export */ var FeatureSection_Tiles = (Tiles);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/ProportalBulletTile.tsx





var ProportalBulletTile = function ProportalBulletTile(_ref) {
  var description = _ref.description,
      title = _ref.title,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
    container: true,
    alignItems: "flex-start",
    direction: "row",
    sx: {
      gap: {
        xs: theme/* theme.spacing */.rS.spacing(1),
        sm: theme/* theme.spacing */.rS.spacing(2),
        md: theme/* theme.spacing */.rS.spacing(3)
      }
    },
    justifyContent: "flex-start",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        backgroundColor: theme/* theme.palette.care.navy.800 */.rS.palette.care.navy[800],
        borderRadius: '50%',
        height: {
          xs: '12px',
          sm: '14px',
          md: '16px'
        },
        marginTop: theme/* theme.spacing */.rS.spacing(0.75),
        width: {
          xs: '12px',
          sm: '14px',
          md: '16px'
        }
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      item: true,
      justifyContent: "space-between",
      xs: 11,
      md: 10,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "h3",
        sx: {
          textAlign: 'left'
        },
        variant: "h3",
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        sx: {
          textAlign: 'left',
          margin: hideTileDescriptionMarginTop ? theme/* theme.spacing */.rS.spacing(0, 0, 1.5) : theme/* theme.spacing */.rS.spacing(3, 0, 3)
        },
        variant: "body2",
        color: "secondary",
        children: description
      })]
    })]
  });
};

/* harmony default export */ var FeatureSection_ProportalBulletTile = (ProportalBulletTile);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/ProportalTiles.tsx




var ProportalTiles_features = [{
  description: 'We manage every aspect of household employer tax compliance, from setting up tax account(s) to filing all required returns and managing tax agency correspondence. At tax time, we prep, file, and distribute W-2s to employees and post a client 1040 Packet containing their completed Schedule H along with records of any 1040-ES payments made through our service. When the time comes, we take care of closing down the state tax accounts.',
  title: 'End-to-End Tax Compliance — Guaranteed',
  key: 1
}, {
  description: 'Stay informed with on-demand access to organized tax records, payment details, and reporting tools. Our dashboard makes it easy to track payroll activity, download reports, and monitor compliance status without sifting through paperwork.',
  title: 'Full Financial Transparency in Real-Time',
  key: 2
}, {
  description: 'Our service automates complex payroll tasks—offering flexible payroll options tailored to household employment. Set default payroll amounts and we’ll withhold the correct taxes, and ensure timely direct deposits, and provide employees with access to paystub records. Payroll updates can be made in seconds using our simple online manager tool. Employees with fluctuating hours can also use our TimeTracker app to easily track and submit their hours for approval and automatic processing.',
  title: 'Streamlined Payroll Processing for Household Employees',
  key: 3
}, {
  description: 'Our intuitive online registration process allows clients and their employees to onboard in less than five minutes. If a client is transitioning over to our service, current year payroll records and/or tax forms can be securely uploaded to their registration.',
  title: 'Effortless Client Onboarding',
  key: 4
}];

var ProportalTiles = function ProportalTiles(_ref) {
  var hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    direction: "column",
    "data-testid": "tiles-container",
    paddingLeft: theme/* theme.spacing */.rS.spacing(6),
    sx: {
      paddingLeft: {
        xs: theme/* theme.spacing */.rS.spacing(3),
        md: theme/* theme.spacing */.rS.spacing(6)
      },
      paddingRight: theme/* theme.spacing */.rS.spacing(3)
    },
    children: ProportalTiles_features.map(function (feature) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_ProportalBulletTile, {
          title: feature.title,
          description: feature.description,
          hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
        })
      }, feature.key);
    })
  });
};

/* harmony default export */ var FeatureSection_ProportalTiles = (ProportalTiles);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/FeatureSection.tsx










var FeatureSection = function FeatureSection(_ref) {
  var title = _ref.title,
      imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt,
      titleOnRight = _ref.titleOnRight,
      hideNumberBackground = _ref.hideNumberBackground,
      hideTileDescriptionMarginTop = _ref.hideTileDescriptionMarginTop,
      _ref$isProportalSecti = _ref.isProportalSection,
      isProportalSection = _ref$isProportalSecti === void 0 ? false : _ref$isProportalSecti,
      description = _ref.description;
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
    sx: {
      overflow: 'hidden',
      padding: {
        xs: theme/* theme.spacing */.rS.spacing(6, 0),
        md: theme/* theme.spacing */.rS.spacing(10, 2)
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      direction: "row",
      justifyContent: "center",
      children: isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: imageAlt,
          "data-testid": "feature-section-img",
          height: 344,
          layout: "responsive",
          loading: "lazy",
          objectFit: "cover",
          src: imageSrc,
          width: 500
        })
      })
    }), !titleOnRight && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          textAlign: "center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            textAlign: "center",
            variant: "display3",
            children: title
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      direction: "row",
      alignItems: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        md: 6,
        children: !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: imageAlt,
          "data-testid": "feature-section-img",
          height: isProportalSection ? 500 : 352,
          layout: "responsive",
          loading: "lazy",
          src: imageSrc,
          objectFit: "fill",
          width: isProportalSection ? 640 : 512,
          style: {
            borderRadius: 16
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        md: 6,
        sm: 12,
        children: isProportalSection ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [titleOnRight && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            justifyContent: "flex-start",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              item: true,
              xs: 11,
              md: 12,
              marginTop: theme/* theme.spacing */.rS.spacing(isMobile ? 4 : 0),
              sx: {
                paddingLeft: {
                  xs: theme/* theme.spacing */.rS.spacing(3),
                  md: theme/* theme.spacing */.rS.spacing(6)
                },
                paddingRight: theme/* theme.spacing */.rS.spacing(3)
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h2",
                variant: "h1",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                marginBottom: theme/* theme.spacing */.rS.spacing(3),
                marginTop: theme/* theme.spacing */.rS.spacing(0.5),
                children: description
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_ProportalTiles, {
            hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [titleOnRight && /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            component: "h2",
            textAlign: "center",
            variant: "display3",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection_Tiles, {
            hideNumberBackground: hideNumberBackground,
            hideTileDescriptionMarginTop: hideTileDescriptionMarginTop
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var FeatureSection_FeatureSection = (FeatureSection);
;// CONCATENATED MODULE: ./src/components/pages/shared/FeatureSection/index.tsx




/***/ }),

/***/ 21438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ homepage_variant1; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(35699);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/hooks/useGTMTracking.ts
var useGTMTracking = __webpack_require__(86229);
// EXTERNAL MODULE: ./src/components/UserProvider/index.ts + 1 modules
var UserProvider = __webpack_require__(44979);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 64 modules
var theme = __webpack_require__(41592);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/special-needs.png
/* harmony default export */ var special_needs = ({"src":"/app/hp-vhp/_next/static/media/special-needs.aa5c87a2.png","height":104,"width":104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuklEQVR42mOAAY2UBYwMaMCs6x5ETL98PxOINm66mGnceL7OpO3aXIsJL5TBkrLO2UBJMOA0abv+ynLiy/9mXXf/6xRsdWSAAXmfSk4eBgY9zYzlnpaTX182qj+zECQMlhTTduQR07JTl7KMlGAHKuJlYHDlYGAwEtdx1oQpEBPTcdIQVbcUkTQJMpIw9LaXMAnUlzDwZoco0HFkBiqSBCoSAtKy4nrucpKmwcwMQCCu68rIgAsAFYMlAdCXKrOd+0vSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Guarantee/Guarantee.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var CheckedDocumentIcon = function CheckedDocumentIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22.24 23.54H5.36a1.19 1.19 0 0 1-1.19-1.19V18a1 1 0 1 1 2 0v3.54h15.26V2.61H6.17v3.86a1 1 0 0 1-2 0V1.8A1.19 1.19 0 0 1 5.36.61h16.88a1.2 1.2 0 0 1 1.19 1.19v20.55a1.19 1.19 0 0 1-1.19 1.19z",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.42 11.66h-5.5a1 1 0 0 1 0-2h5.5a1 1 0 1 1 0 2zm0 3.73h-5.5a1 1 0 1 1 0-2h5.5a1 1 0 0 1 0 2z",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.62 18.55A6.31 6.31 0 1 1 6.6 5.93a6.31 6.31 0 0 1 .02 12.621zm0-10.61a4.31 4.31 0 1 0-.02 8.62 4.31 4.31 0 0 0 .02-8.62z",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m5.06 12.61.99.96 2.7-2.65",
      fill: "#3A94ED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.05 14.57a1 1 0 0 1-.7-.28l-1-1a1 1 0 1 1 1.4-1.43l.29.28 2-2a1 1 0 1 1 1.41 1.42l-2.7 2.64a1 1 0 0 1-.7.37z",
      fill: "#3A94ED"
    })]
  }));
};

CheckedDocumentIcon.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};


var StarIcon = function StarIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.94 22.28a1.78 1.78 0 0 1-.83-.22L12 19.2l-5.19 2.7A1.7 1.7 0 0 1 5 21.76a1.67 1.67 0 0 1-.67-1.67l1-5.76-4.18-4.08a1.72 1.72 0 0 1 .092-2.54 1.69 1.69 0 0 1 .858-.38l5.79-.83 2.6-5.09A1.7 1.7 0 0 1 12 .47a1.7 1.7 0 0 1 1.52.94l2.59 5.12 5.81 1a1.71 1.71 0 0 1 .88 2.94l-4.16 3.9 1 5.92a1.68 1.68 0 0 1-.7 1.67 1.72 1.72 0 0 1-1 .32zm-6-5.22a1 1 0 0 1 .49.13L17.56 20l-1-5.85a1 1 0 0 1 .3-.89L21 9.4l-5.74-1a1 1 0 0 1-.72-.54L12 2.82 9.44 7.87a1 1 0 0 1-.75.54L3 9.23l4.14 4a1 1 0 0 1 .28.89l-1 5.7 5.12-2.68a1 1 0 0 1 .46-.08h-.06z",
      fill: "#3A94ED"
    })
  }));
};

StarIcon.defaultProps = {
  width: "24",
  height: "23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};




var Guarantee = function Guarantee() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
        margin: '120px auto'
      },
      margin: '0 auto 39px auto'
    },
    maxWidth: "lg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        sm: 6,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            alt: "Our happiness guarantee",
            height: 100,
            layout: "intrinsic",
            loading: "lazy",
            src: special_needs,
            width: 100
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            textAlign: "center",
            variant: "h1",
            children: ["We guarantee your", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "happiness and our service"]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        sm: 6,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
          sx: {
            padding: '16px 24px',
            textAlign: 'center',
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
              padding: '10px 30px 0 0',
              textAlign: 'left'
            },
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('xl')]: {
              paddingRight: '128px'
            }
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Guarantee_GuaranteeItem, {
            description: "If HomePay doesn't meet your expectations for an all-in-one nanny tax and payroll service during your first six months of use, we'll refund your payments for our services.**",
            serviceIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(StarIcon, {}),
            title: "Happiness guarantee"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            pt: "24px"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Guarantee_GuaranteeItem, {
            description: "We guarantee that your tax returns are filed accurately and on time.***",
            serviceIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckedDocumentIcon, {}),
            title: "Service guarantee"
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var Guarantee_Guarantee = (Guarantee);
// EXTERNAL MODULE: ./node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Guarantee/GuaranteeItem.tsx




var GuaranteeItem = function GuaranteeItem(_ref) {
  var description = _ref.description,
      serviceIcon = _ref.serviceIcon,
      title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    sx: {
      display: {
        sm: 'inline-flex'
      },
      '& img': {
        marginRight: {
          sm: 12
        }
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
      mdDown: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        marginRight: "12px",
        width: "24px",
        children: serviceIcon
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
      variant: "body1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
        mdDown: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("b", {
          children: [title, ":"]
        }), ' ']
      }), description]
    })]
  });
};

/* harmony default export */ var Guarantee_GuaranteeItem = (GuaranteeItem);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Guarantee/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/ramda/es/includes.js
var includes = __webpack_require__(43068);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 9 modules
var ui = __webpack_require__(20935);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
;// CONCATENATED MODULE: ./src/assets/images/child-care.png
/* harmony default export */ var child_care = ({"src":"/app/hp-vhp/_next/static/media/child-care.7ec08373.png","height":121,"width":121,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA5UlEQVR42mOAAUU9F1ZjY09OEPv/yktSDDAgpu3ICKJldJx01PRd3RkYGCTeTN7R/rtpenAhAwMzAwiUpVrzOTg4GJlaOEir6TmbMjAwKF3yNs/8nx4kwMAABn6SDAzulgx8TnpZsdbCzmZ++gyC7ioMMLBnll7iim7jipXdxvwgvqGFo4KXvpMqAwj8v8xu/eu0wP/ne2T+fz4q9u7cSo1OBgZ37dRIWz4GEDizXJXp/0XO7m8nRD68PSj5/+U+6RMMDFksILnGXCtGBhj4f49B7P91BrP/7xl4QfwtUwyZGBgYGADIB0DxW4YZ0QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/senior-care.png
/* harmony default export */ var senior_care = ({"src":"/app/hp-vhp/_next/static/media/senior-care.d4fe1c1b.png","height":80,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuklEQVR42mMAA00nJgYk8L/FnbHYAiGGACqOTgxajiEwbpUVTJGko+pUO6fcOkunolAjp9qVLk4znQyc1BlgYKGTU/+dIOdfZ/ycn652dXrzOMT5/2Z35y0MMDDHyal2uavT/6M+zn+vBjr/ASr+v93TeRcDAtgw99k7HVkGVHTM1xms8IiPsxYDCMjqwxxiw1Ri5bRwlavzy1tBztYMQLDIxYmFAQTKrRBe+l/kyskABLOdnJkZGBgYAENOPDkwtmReAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/household.png
/* harmony default export */ var household = ({"src":"/app/hp-vhp/_next/static/media/household.fccd9f7b.png","height":80,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuElEQVR42mMQ03FkZIACMW0nDgYoENd2goszABVpiGk75kjoOsZK6DoFARXKoygCSqpL6Dk6Cao5tknpOy5UtnZSYQACeTNHJgZRTScmsCpGJwkFC6d8BganXCB2ZAADJ2YG21igKjBwMqje5PC/dJXDf+9CxwwGIIhqdWRhULZ2ZAbL8zmZeOQ6Hs5b6LDXPccxmgEI/EqBCnjkIb4Q13EUZWBw8gBidyBWh5oKMV3WGKgIA0B8AACFVCHkWzcWdAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/RightChoice/RightChoice.tsx













var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL,
    HOUSEHOLD_URL = publicRuntimeConfig.HOUSEHOLD_URL;
var RIGHT_CHOICES = [{
  iconSrc: child_care,
  label: 'Child care',
  url: null
}, {
  iconSrc: senior_care,
  label: 'Senior care',
  url: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.seniorCare.relativeURL */.ZY.seniorCare.relativeURL)
}, {
  iconSrc: household,
  label: 'Household',
  url: HOUSEHOLD_URL
}];

var RightChoice = function RightChoice() {
  var choices = RIGHT_CHOICES.map(function (choice) {
    var iconTile = /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: {
        marginBottom: {
          xs: '4px',
          md: '0px'
        }
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* IconTile */.$X, {
        iconSrc: choice.iconSrc,
        label: choice.label
      }, choice.label)
    }, choice.label);

    if (choice.url) {
      var href = (0,includes/* default */.Z)('http', choice.url) ? choice.url : "/".concat(choice.url);
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: href,
        onClick: function onClick() {
          (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
            data: {
              cta_location: 'HomePay VHP',
              cta_text: choice.label
            },
            name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
            pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
          });
        },
        children: iconTile
      }, choice.label);
    }

    return iconTile;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      padding: theme/* theme.spacing */.rS.spacing(8, 0, 8)
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          display: "flex",
          justifyContent: "center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "display3",
            fontSize: [28, 36],
            textAlign: "center",
            mb: 7,
            mt: 0,
            mx: [1, 14],
            lineHeight: "34px",
            children: "The right choice for all\xA0household employers"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          "data-testid": "choices-wrapper",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 2,
          children: choices
        })
      })]
    })
  });
};

/* harmony default export */ var RightChoice_RightChoice = (RightChoice);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/RightChoice/index.ts

// EXTERNAL MODULE: ./src/components/pages/shared/ModalVideo/ModalVideo.tsx
var ModalVideo = __webpack_require__(75652);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
;// CONCATENATED MODULE: ./src/assets/images/nannyhelp-mw.png
/* harmony default export */ var nannyhelp_mw = ({"src":"/app/hp-vhp/_next/static/media/nannyhelp-mw.bf4fefd1.png","height":316,"width":375,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAuklEQVR42gGvAFD/AJSNfs3Ny+z2/+fv9q6pn5yYkI2NiYqMiwCempLX1tPr9f3r8/rSzL+trquusrGyu8IAztTY2+Dj6/T77fb+m5mYhmZWv7awurm8AOTr8eLq8N/m7Nnf4p+Kd6RzRGhQQaWlpgDN0dXO1Nmzr7GmmJKlg1eum5JwcHWxuLwAv8rTrbC0fmJVmomSXFRqn5yno6mypqyuAHuFjWBnbZyXlaqttZOYpGp5hICMkoWKjiaqcS7aUb5LAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/assets/images/nannyhelp.png
/* harmony default export */ var nannyhelp = ({"src":"/app/hp-vhp/_next/static/media/nannyhelp.fb409595.png","height":474,"width":563,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAuklEQVR42gGvAFD/AJSNfs3Ny+z2/+fv9q6onpyYkI2NiYqMiwCempLX1tPr9f3r8/rRy7+trquus7Gyu8IAztTY2+Dk6/T77fb9m5iYh2dXv7exubm8AOTr8eLq8N/m7Njf4p+Kd6RzRGhRQaampwDN0dXO1Nmzr7KnmJOlhFmvnJNwcHaxuL0Av8rTrbC0fmJXmomTXVZroZ6oo6qypqyuAHuFjWBnbZyXlqqttZOYpGp6hICMkoWKjSttcUr2wgU5AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/assets/images/check.png
/* harmony default export */ var check = ({"src":"/app/hp-vhp/_next/static/media/check.bc35da54.png","height":24,"width":24,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAoUlEQVR42k2PPQrCQBCFp7IULG1sbAxeIJOczAuIhY3ZWNhYCCEEjFst3kl29Qp+GzYkDz6Y3Te/EqUmKPRah0aN78BCPpo5OK18JkmYW3AUaHy8YDDL63chKL/4JUU7/nvR2reCiuqzEkSnA8YxdW9jwmNIMOGOcYOzJOF1Mcsya1Oa35r4NNtjD/14wTsuNpkhAzddQgAWnrRtYiUUIiJ/9QhjKZHUcCgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/NannyHelp/NannyHelp.tsx















var NannyHelp = function NannyHelp() {
  var _theme$palette$care2;

  var _useState = (0,react.useState)(false),
      isVisible = _useState[0],
      setVisibility = _useState[1];

  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  var rightImageSrc = isMobile ? nannyhelp_mw : nannyhelp;

  var toggleModalVisibility = function toggleModalVisibility() {
    return setVisibility(function (_isVisible) {
      return !_isVisible;
    });
  };

  var handleVideoButtonClick = function handleVideoButtonClick() {
    toggleModalVisibility();
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'homepayhelps',
        cta_text: 'PlayVideo_Laura'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  var renderFeatureList = function renderFeatureList() {
    return constants/* NANNY_HELP_FEATURES.map */.zQ.map(function (feature) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        style: {
          display: 'flex',
          margin: '0 0 14px 0'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          height: 24,
          width: 24,
          src: check,
          alt: "nanny-image"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          component: "span",
          variant: "body1",
          fontSize: [16, 16, 18],
          ml: 1.5,
          mb: 0,
          children: feature
        })]
      }, feature);
    });
  };

  var renderContentGrid = function renderContentGrid() {
    var _theme$palette$care;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      sx: {
        [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
          margin: '0 auto'
        }
      },
      item: true,
      md: 7,
      sm: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          '& .feature-list-wrapper': {
            display: 'inline-flex',
            margin: '0 auto'
          },
          '& h2': {
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              fontSize: '36px',
              lineHeight: '42px',
              padding: '0px 50px 40px 0'
            },
            color: theme/* theme.palette.text.primary */.rS.palette.text.primary,
            fontSize: '28px',
            fontWeight: 'bold',
            lineHeight: '34px',
            padding: '40px 0px 32px 24px'
          },
          '& li': {
            listStyleType: 'none',
            marginBottom: '8px',
            paddingLeft: '0px'
          },
          '& p': {
            fontSize: '18px',
            lineHeight: '24px',
            marginBottom: '10px'
          },
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
            borderRadius: '16px',
            height: '442px',
            padding: '56px 0 0 66px',
            textAlign: 'left'
          },
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('xl')]: {
            marginLeft: '70px'
          },
          '& ul': {
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              fontSize: '18px',
              lineHeight: '24px',
              paddingLeft: '0'
            },
            marginBottom: '10px',
            marginTop: '16px',
            paddingLeft: '0px',
            textAlign: 'left'
          },
          backgroundColor: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.grey[50],
          padding: '0 0 40px',
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          "data-testid": "nanny-help-heading",
          variant: "h2",
          children: "HomePay helps your nanny, too"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          component: "p",
          children: ["Paying legally helps your nanny\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(Hidden/* default */.Z, {
            smUp: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})
          }), "qualify for:"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          className: "feature-list-wrapper",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            "data-testid": "feature-list",
            children: renderFeatureList()
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* PlayButtonLink */.e3, {
            "data-testid": "watch-story-link",
            onClick: handleVideoButtonClick,
            children: "See how HomePay helped Laura"
          })
        })]
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      marginBottom: theme/* theme.spacing */.rS.spacing(3.625),
      padding: theme/* theme.spacing */.rS.spacing(12, 6, 4, 6),
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        backgroundColor: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.grey[50],
        padding: 0
      }
    },
    maxWidth: "xl",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
      container: true,
      spacing: 0,
      children: [!isMobile && renderContentGrid(), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        sx: {
          '& span': {
            overflow: 'unset !important'
          },
          position: 'relative',
          width: '100%'
        },
        item: true,
        md: 5,
        sm: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
              bottom: 'unset !important',
              left: '-60px !important',
              position: 'absolute',
              right: 'unset !important',
              top: '-48px !important',
              zIndex: 100
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            alt: "Nanny help",
            "data-testid": "nanny-help-right-image",
            height: !isMobile ? 434 : 316,
            layout: isMobile ? 'responsive' : 'intrinsic',
            loading: "lazy",
            src: rightImageSrc,
            width: !isMobile ? 570 : 375,
            style: {
              borderRadius: isMobile ? 0 : '16px'
            }
          })
        })
      }), isMobile && renderContentGrid(), /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo/* default */.Z, {
        dataTestId: "homepage-how-homepay-helps-modal",
        isVisible: isVisible,
        onClose: toggleModalVisibility,
        title: "See how HomePay helps Laura",
        videoUrl: constants/* HOW_HP_HELPS_LAURA_VIDEO_URL */.Lo
      })]
    })
  });
};

/* harmony default export */ var NannyHelp_NannyHelp = (NannyHelp);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/NannyHelp/index.ts

// EXTERNAL MODULE: ./src/components/pages/shared/Help/variant1/index.ts + 2 modules
var variant1 = __webpack_require__(76929);
// EXTERNAL MODULE: ./src/components/pages/homepage/variant1/Layout/index.ts + 1 modules
var variant1_Layout = __webpack_require__(93218);
// EXTERNAL MODULE: ./src/components/pages/shared/Testimonials/index.ts + 3 modules
var Testimonials = __webpack_require__(41771);
;// CONCATENATED MODULE: ./src/assets/images/familydepends-mw.jpg
/* harmony default export */ var familydepends_mw = ({"src":"/app/hp-vhp/_next/static/media/familydepends-mw.5081ac17.jpg","height":316,"width":375,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAcACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAABP/aAAwDAQACEAMQAAAApgdP/8QAHhAAAgEDBQAAAAAAAAAAAAAAAQIDAARxBREhMTL/2gAIAQEAAT8A1K+hKzq8HuE8MewMb5r/xAAZEQEAAgMAAAAAAAAAAAAAAAACABEDITH/2gAIAQIBAT8Ayk2ddNz/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQMSgf/aAAgBAwEBPwCFuun/2Q==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/assets/images/familydepends.png
/* harmony default export */ var familydepends = ({"src":"/app/hp-vhp/_next/static/media/familydepends.50fd572c.png","height":580,"width":580,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAUlEQVR42gWAzUrCcADA/+8U9BIdunrJW5Qe6hwYzGhgoR4U8xBqSGYZfrSy0HBlilEqaH6QYc6J5oqRPcF+ISa6Zs2nE3JKHOnAQbddR2/Vybi22LUtWcIw5rwVL3lJeGlUCgz6LcadDp3jIIG1ZcSPadJ/umWkRJn2mjRVhepZHPNrRkZ2IBaLPz6HOo3HB8YfPfThO/VsEtOYoVUvEN/mL4OBRjaV47VWpla4Ix/ykgx6OAlICJtzE7X8TLtaw729QezIR7eichOQ2bevIqKnUfzxe1KRK3xyDNdhmFJR4Tp9TlpaR4xGfStfUnGHE8ihBM6dCEnJRc7vYc++Yv0DVn/ET0dDJ6IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/Reviews.tsx









var Reviews = function Reviews() {
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();
  var imageURI = isMobile ? familydepends_mw : familydepends;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    sx: {
      padding: theme/* theme.spacing */.rS.spacing(12, 7, 2.5, 11),
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        padding: 0
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Testimonials/* default */.Z, {
      title: "Families depend on HomePay",
      imageURI: imageURI,
      reviews: constants/* reviews */.A9
    })
  });
};

/* harmony default export */ var variant1_Reviews = (Reviews);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./src/assets/images/headset.png
var headset = __webpack_require__(68796);
// EXTERNAL MODULE: ./src/components/pages/shared/EnrollmentCTA/EnrollmentCTA.tsx + 1 modules
var EnrollmentCTA = __webpack_require__(676);
;// CONCATENATED MODULE: ./src/components/pages/shared/GetStarted/variant2/GetStarted.tsx










var GetStarted = function GetStarted(_ref) {
  var _theme$palette$care, _theme$palette$care2, _theme$palette$care3, _theme$palette$care4;

  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      heroImageUri = _ref.heroImageUri;
  var isMobile = (0,useMediaQuery/* default */.Z)(theme/* theme.breakpoints.down */.rS.breakpoints.down('md'));

  var handlePhoneClick = function handlePhoneClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Main VHP - Phone Banner',
        cta_text: "".concat(constants/* PHONE_LABEL */.el)
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
    disableGutters: true,
    maxWidth: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      sx: {
        alignItems: 'center',
        background: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.red[100],
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        padding: theme/* theme.spacing */.rS.spacing(0.5)
      },
      width: "100%",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        alt: "Claim Exclusive Offer",
        height: 40,
        src: headset/* default */.Z,
        width: 40
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "body3",
        children: "Claim Exclusive Offer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          margin: theme/* theme.spacing */.rS.spacing(0, 0.5),
          fontWeight: 700
        },
        "data-testid": "phone-number-link",
        onClick: handlePhoneClick,
        href: constants/* PHONE_LINK */.v,
        rel: "nofollow",
        children: constants/* PHONE_LABEL */.el
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      sx: {
        background: (_theme$palette$care2 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care2 === void 0 ? void 0 : _theme$palette$care2.navy[900],
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
          marginBottom: theme/* theme.spacing */.rS.spacing(-6.25)
        },
        overflow: 'visible'
      },
      disableGutters: true,
      maxWidth: false,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        sx: {
          paddingLeft: 0,
          paddingRight: 0
        },
        container: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              paddingLeft: theme/* theme.spacing */.rS.spacing(2),
              [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                paddingLeft: 0
              }
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
              sx: {
                [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
                  padding: theme/* theme.spacing */.rS.spacing(8, 4, 8)
                },
                [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                  padding: theme/* theme.spacing */.rS.spacing(2)
                }
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                  color: (_theme$palette$care3 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care3 === void 0 ? void 0 : _theme$palette$care3.white,
                  margin: theme/* theme.spacing */.rS.spacing(0, 'auto'),
                  paddingTop: 0,
                  textAlign: 'left',
                  [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                    paddingTop: theme/* theme.spacing */.rS.spacing(1.5),
                    textAlign: 'center'
                  }
                },
                variant: isMobile ? 'serifHeadline2' : 'serifDisplay2',
                children: heading
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                  color: (_theme$palette$care4 = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care4 === void 0 ? void 0 : _theme$palette$care4.white,
                  fontSize: '28px',
                  letterSpacing: '0.5px',
                  lineHeight: '34px',
                  margin: theme/* theme.spacing */.rS.spacing(2.5, 'auto', 1.875, 0),
                  width: '82%',
                  [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
                    fontSize: '18px',
                    lineHeight: '24px',
                    marginLeft: 0,
                    textAlign: 'center',
                    width: '100%'
                  }
                },
                variant: isMobile ? 'body1' : undefined,
                children: subHeading
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(EnrollmentCTA/* default */.Z, {
                ctaLocation: "HomePay VHP Variant 2 Hero",
                pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
              })]
            })
          })
        }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          sx: {
            overflow: 'visible',
            position: 'relative'
          },
          item: true,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              [theme/* theme.breakpoints.down */.rS.breakpoints.down('lg')]: {
                'clip-path': 'circle(75% at 75% 70%)'
              },
              height: 450,
              width: '100%',
              'clip-path': 'circle(85% at 75% 57.5%)'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: heroImageUri,
              width: 800,
              height: 450,
              layout: "fill",
              objectPosition: "right",
              objectFit: "cover",
              "data-testid": "hero-image",
              quality: 100
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var variant2_GetStarted = (GetStarted);
;// CONCATENATED MODULE: ./src/components/pages/shared/GetStarted/variant2/index.ts

;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Hero.tsx




var Hero = function Hero() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(variant2_GetStarted, {
    heading: "Pay your nanny legally, save time and money",
    subHeading: "Let our HomePay experts handle your household tax and payroll needs.",
    heroImageUri: nannyhelp
  });
};

/* harmony default export */ var variant2_Hero = (Hero);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallCalculator.js
var IconIllustrationSmallCalculator = __webpack_require__(73103);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconIllustrationSmallNannies.js
var IconIllustrationSmallNannies = __webpack_require__(22306);
;// CONCATENATED MODULE: ./src/assets/images/instant-payment.png
/* harmony default export */ var instant_payment = ({"src":"/app/hp-vhp/_next/static/media/instant-payment.9cdab536.png","height":150,"width":150,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAwElEQVR42mPABhQtnTgZGBwZUQSP/bfl+P/fhP3KfxtuTllHPbjE4ld2bkte2+2ddc9+W+FSh/PJEx126Xk6yjAwOLGCFSx8Yd804YL9/zkP7f+nTnX4D5T4L23oOEFSz9FMTNuJhWH+U/u8zmP2//vP2/+fet3+v12840sGFqcjKjaOFuLaQFPW/7YTmn3ffn/7YfsHZWsdSoGSK2SNHdMxXO6YDLLXWRJDYsZteyYIy4nTr8SRD8QS03JkgckDAIxRP1FIU18jAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronRight.js
var Icon24UtilityChevronRight = __webpack_require__(16178);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Services/ServiceTile.tsx













var ServiceTile = function ServiceTile(_ref) {
  var description = _ref.description,
      icon = _ref.icon,
      label = _ref.label,
      mobileDescription = _ref.mobileDescription,
      url = _ref.url;
  var isMobile = (0,hooks/* useMobileQuery */.Lh)();

  var handleTileClick = function handleTileClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'HomePay VHP Variant 2 Hero',
        cta_text: label
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    item: true,
    md: 3,
    xs: 12,
    sx: {
      display: 'flex',
      width: '100%'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: url,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        sx: {
          display: 'flex',
          width: '100%'
        },
        href: url,
        onClick: handleTileClick,
        underline: "none",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
          careVariant: "subtle",
          sx: {
            opacity: {
              xs: 0.85,
              md: 1
            },
            width: '100%'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardContent/* default */.Z, {
            sx: {
              height: '100%'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              sx: {
                height: '100%'
              },
              container: true,
              direction: isMobile ? 'row' : 'column',
              wrap: "nowrap",
              children: [/*#__PURE__*/(0,react.isValidElement)(icon) ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: icon
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                alt: "Service icon",
                height: 45,
                layout: "fixed",
                src: icon,
                width: 45
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                direction: "column",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "h3",
                  children: label
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
                  variant: "body3",
                  color: "secondary",
                  children: mobileDescription && isMobile ? mobileDescription : description
                })]
              }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                sx: {
                  margin: 'auto 0 0 auto'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon24UtilityChevronRight/* default */.Z, {})
              })]
            })
          })
        })
      }, label)
    })
  });
};

/* harmony default export */ var Services_ServiceTile = (ServiceTile);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Services/Services.tsx









var Services_ref = config_default()(),
    Services_publicRuntimeConfig = Services_ref.publicRuntimeConfig;

var Services_HOMEPAY_URL = Services_publicRuntimeConfig.HOMEPAY_URL,
    NTG_URL = Services_publicRuntimeConfig.NTG_URL,
    SNC_URL = Services_publicRuntimeConfig.SNC_URL;
var SERVICES = [{
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconIllustrationSmallCalculator/* default */.Z, {
    size: 45
  }),
  label: 'Budget & tax calculator',
  description: 'Access our household employer budget and tax calculators',
  mobileDescription: 'Access our household employer tools',
  url: "".concat(Services_HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.nannyTaxCalculator.relativeURL */.ZY.nannyTaxCalculator.relativeURL)
}, {
  icon: instant_payment,
  label: 'Sample nanny contract',
  description: 'Get more money back this tax season',
  url: SNC_URL
}, {
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(IconIllustrationSmallNannies/* default */.Z, {
    size: 45
  }),
  label: 'Nanny tax guide',
  description: "Let us handle it so you don't have to",
  url: NTG_URL
}];

var Services = function Services() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
    sx: {
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        overflow: 'hidden',
        paddingTop: theme/* theme.spacing */.rS.spacing(3),
        paddingBottom: theme/* theme.spacing */.rS.spacing(1.875)
      },
      position: 'relative'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      container: true,
      sx: {
        zIndex: 20
      },
      "data-testid": "services-container",
      direction: "row",
      justifyContent: "center",
      spacing: 3,
      children: SERVICES.map(function (service) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Services_ServiceTile, {
          description: service.description,
          icon: service.icon,
          label: service.label,
          mobileDescription: service.mobileDescription && service.mobileDescription,
          url: service.url
        }, service.label);
      })
    })
  });
};

/* harmony default export */ var Services_Services = (Services);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/Services/index.ts

;// CONCATENATED MODULE: ./src/assets/images/how-homepay-works.png
/* harmony default export */ var how_homepay_works = ({"src":"/app/hp-vhp/_next/static/media/how-homepay-works.fb0e1022.png","height":344,"width":462,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAAoUlEQVR42gGWAGn/AN3f4OHl5uLn6Nvg4tXW2MvMzrixrMnAuwDo6+zZ2NmzqaewoJzT0tTc3+LWzMPJtKUA0tPUoIuFfFlPjFtHvrWzwcLCsKyiysG6ALG0un92eHJpaYaBg7CgmZWEeKCYk9zg5ADMw8HEubOoiXWnkY2hjIWDbViSg3q+rKMA6Onx3tDJwYU+w5yAqI19hlMSlGZEpHxgi95gjWzAWPAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./src/components/pages/shared/FeatureSection/index.tsx + 5 modules
var FeatureSection = __webpack_require__(90683);
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant2/HowItWorks.tsx



function HowItWorks() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSection/* default */.ZP, {
    title: "How it works",
    imageSrc: how_homepay_works.src,
    imageAlt: "How Homepay works"
  });
}
;// CONCATENATED MODULE: ./src/components/pages/homepage/variant1/index.tsx

















var Homepage = function Homepage() {
  var _useUserAuth = (0,UserProvider/* useUserAuth */.Ii)(),
      auth = _useUserAuth.auth;

  (0,useGTMTracking/* default */.Z)({
    pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP,
    slots: [].concat((0,toConsumableArray/* default */.Z)(auth !== null && auth !== void 0 && auth.isLoggedIn ? [] : constants/* GTM_DATA.nonMember.slots */.cd.nonMember.slots), (0,toConsumableArray/* default */.Z)(constants/* GTM_DATA.mainVHP.slots */.cd.mainVHP.slots))
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
    FooterComponent: variant1_Layout/* HomepageFooter */.w,
    sx: {
      paddingLeft: '0 !important',
      paddingRight: '0 !important'
    },
    maxWidth: false,
    meta: constants/* META_PROPERTIES.mainVHP */.b_.mainVHP,
    pageProperties: constants/* PAGE_PROPERTIES.mainVHP */.vk.mainVHP,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(variant2_Hero, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Services_Services, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(variant1_Reviews, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RightChoice_RightChoice, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(NannyHelp_NannyHelp, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Guarantee_Guarantee, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(variant1/* default */.Z, {})]
  });
};

/* harmony default export */ var homepage_variant1 = (Homepage);
;// CONCATENATED MODULE: ./src/pages/index.ts


/***/ }),

/***/ 89886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(21438);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [611,1821,7423,3340,1614,7060,1724,11,9471,7876,5699,1230,8186,9774,2888,179], function() { return __webpack_exec__(89886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);